import { Pipe, PipeTransform } from '@angular/core';
import {
  DataViewStyle,
  FieldPresenterModel,
  ViewStyleConfig,
} from '@osos/shared/types';

@Pipe({
  standalone: true,
  name: 'getEntryFieldWrapperClass',
})
export class GetEntryFieldWrapperClassPipe implements PipeTransform {
  transform(
    field: FieldPresenterModel,
    viewStyleConfigProp: keyof ViewStyleConfig,
    uiAttributes: DataViewStyle,
  ): string {
    if (!field || !viewStyleConfigProp || !uiAttributes) {
      return '';
    }
    const fieldNormalizedName = field._normalizedName ?? '';

    const fieldClass =
      uiAttributes?.fieldClasses?.[field._normalizedName]?.[
        viewStyleConfigProp
      ] ?? '';

    const generalFieldClass =
      uiAttributes?.fieldClasses?.[field._normalizedName]?.general ?? '';
    if (fieldClass == '' && generalFieldClass == '') return '';

    return `${fieldNormalizedName} ${generalFieldClass} ${fieldClass}`;
  }
}
